import angular from "angular";

import uiRouterModule from "@uirouter/angularjs";

import TrackerBaseReportsConstants from "./Constants";
import ReportConfiguration from "./ReportConfiguration";
import DependencyListBuilder from "../../utility/DependencyListBuilder";

import TrackingTargetEventsReportController from "./TrackingTargetEventsReportController";

const reportConfiguration = new ReportConfiguration({
    reportDisplayName: "Tracking Target Events",
    reportStateName: "targetEvents"
});

function TrackingTargetEventsReportConfiguration($stateProvider) {

    $stateProvider.state(
        `${TrackerBaseReportsConstants.rootStateName}.${reportConfiguration.stateName}`, 
        {
            url: "/tracking-target-events",
            template: TrackingTargetEventsReportController.template,
            controller: TrackingTargetEventsReportController,
            controllerAs: TrackingTargetEventsReportController.controllerAs
        }
    );
}

TrackingTargetEventsReportConfiguration.$inject = [ "$stateProvider" ];

TrackingTargetEventsReportConfiguration.dependencies = [ uiRouterModule ];

const trackingTargetEventsReportModuleDependencies = DependencyListBuilder([
    TrackingTargetEventsReportController.dependencies,
    TrackingTargetEventsReportConfiguration.dependencies
]);

export default {
    moduleName: angular
        .module(
            "trackerbase-app.views.trackerbase-reports.tracking-target-events-report",
            trackingTargetEventsReportModuleDependencies
        )
        .config(TrackingTargetEventsReportConfiguration)
        .name,
    configs: [ reportConfiguration ]
};



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/TrackingTargetEventsReport.js
// module id = VSQF
// module chunks = 1